import axios from 'axios';
import { LabHoursUsedByCourse, ReporteeLabHoursUsed } from 'types/labs';
import { LAB_USED_COURSE } from '../config/constants';

const { get, post } = axios;

export type LabHoursUsedByCourseResponse = {
  items: LabHoursUsedByCourse[];
};

export const getLabUsedHoursGroupByCourse = async (): Promise<
  LabHoursUsedByCourseResponse | undefined
> => {
  const response = await get<LabHoursUsedByCourseResponse>(LAB_USED_COURSE);
  return response?.data;
};

export const getReporteesLabHours = async (
  users: string[],
  signal?: AbortSignal,
): Promise<ReporteeLabHoursUsed[]> => {
  const request = { users };
  const response = await post<{ items: ReporteeLabHoursUsed[] }>(
    `${LAB_USED_COURSE}me/users/`,
    request,
    { signal },
  );
  return response.data.items;
};
